import { Link } from "react-router-dom";

const promises = [
  {
    icon: "ri-shield-check-line",
    title: "权威收录",
    text: "人工筛选优质站点，信息真实可靠，分类清晰易查。",
  },
  {
    icon: "ri-flashlight-line",
    title: "快速直达",
    text: "首页与分类页均可一键直达目标网站，减少跳转成本。",
  },
  {
    icon: "ri-refresh-line",
    title: "持续更新",
    text: "定期补充热门与新兴网站，保持资源新鲜实用。",
  },
];

export default function SiteIntro() {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
      <div>
        <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
          <i className="ri-information-line" />
          关于我们
        </span>
        <h2 className="font-heading font-extrabold text-2xl md:text-3xl text-foreground-950 leading-snug">
          51网址导航，让每一次网络访问都更高效
        </h2>
        <p className="text-sm md:text-base text-foreground-600 mt-4 leading-relaxed">
          我们致力于成为权威且实用的网站入口集合门户。通过分类索引与精选推荐，帮助用户快速定位并访问热门及特色网站，覆盖新闻、购物、社交、学习、工具等常用场景。
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-7">
          {promises.map((item) => (
            <div key={item.title} className="p-4 rounded-xl bg-background-100 border border-background-200">
              <span className="w-9 h-9 rounded-lg bg-background-50 text-primary-600 flex items-center justify-center mb-3">
                <i className={`${item.icon} text-lg`} />
              </span>
              <h3 className="font-heading font-semibold text-sm text-foreground-950">{item.title}</h3>
              <p className="text-xs text-foreground-500 mt-1.5 leading-relaxed">{item.text}</p>
            </div>
          ))}
        </div>

        <Link
          to="/about"
          className="inline-flex items-center gap-1.5 mt-6 text-sm text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
        >
          了解更多关于 51网址导航
          <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="relative">
        <div className="w-full aspect-[4/3] rounded-2xl overflow-hidden border border-background-200">
          <img
            src="https://readdy.ai/api/search-image?query=Clean%20modern%20workspace%20desk%20with%20laptop%20showing%20a%20colorful%20website%20directory%20grid%2C%20soft%20natural%20daylight%2C%20minimal%20blue%20and%20white%20color%20palette%2C%20organized%20and%20professional%20atmosphere%2C%20high%20detail&width=1000&height=750&seq=nav-intro-01&orientation=landscape"
            alt="51网址导航使用场景"
            title="51网址导航 - 分类索引与快速访问"
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="absolute -bottom-5 -left-3 md:left-auto md:-right-5 bg-background-50 border border-background-200 rounded-xl px-5 py-4">
          <p className="font-heading font-extrabold text-2xl text-primary-600">50+</p>
          <p className="text-xs text-foreground-500 mt-1">精选优质网址</p>
        </div>
      </div>
    </div>
  );
}